<!-- Poste verrouille : l'application derriere est inerte (ni clavier, ni lecteur d'ecran). -->
<div class="font-sans min-h-screen transition-colors duration-200" [attr.inert]="verrou.verrouille() ? '' : null" [ngClass]="darkMode() ? 'bg-surface-950 text-white' : 'bg-surface-50 text-gray-900'">

  <!-- Top Header -->
  <header class="fixed top-0 left-0 right-0 h-14 flex items-center justify-between px-4 transition-colors z-40 border-b"
          [ngClass]="darkMode() ? 'bg-surface-900 border-surface-700' : 'bg-white border-surface-200'">

      <div class="flex items-center gap-2">
       <img src="assets/logo.svg" alt="Konbit POS" class="w-10 h-10 object-contain rounded-xl" />
       <h1 class="font-bold text-lg hidden sm:block" [ngClass]="darkMode() ? 'text-white' : 'text-surface-800'">{{ t().header.title }}</h1>
       <!-- Session ouverte par PIN sans reseau : aucun jeton en memoire, rattachee au retour du reseau. -->
       <span *ngIf="authService.sessionHorsLigne()" role="status"
             class="px-2 py-0.5 rounded-full text-xs font-semibold bg-accent-100 text-accent-800 dark:bg-accent-900/40 dark:text-accent-300">
         {{ t().login.offline_session }}
       </span>
    </div>

    <div class="flex items-center gap-2">

      <!-- Language Dropdown -->
      <div class="relative">
        <button
          (click)="toggleLanguageMenu()"
          class="w-10 h-10 rounded-full hover:bg-surface-100 dark:hover:bg-surface-700 flex items-center justify-center transition-colors text-xl"
          title="{{ t().header.lang }}"
        >
           {{ currentLanguage().flag }}
        </button>

        <!-- Dropdown Menu -->
        <div *ngIf="showLanguageMenu()"
             class="absolute top-full right-0 mt-2 w-48 bg-white dark:bg-surface-800 rounded-xl shadow-xl border border-surface-100 dark:border-surface-700 overflow-hidden py-1 z-50 animate-in fade-in zoom-in-95 duration-200">
          <button
            *ngFor="let lang of languages"
            (click)="setLanguage(lang)"
            class="w-full px-4 py-3 text-left flex items-center gap-3 hover:bg-surface-50 dark:hover:bg-surface-700 transition-colors"
            [class.bg-primary-50]="currentLanguage().code === lang.code"
            [class.dark:bg-primary-900/30]="currentLanguage().code === lang.code"
          >
            <span class="text-2xl">{{ lang.flag }}</span>
            <span class="font-medium text-surface-700 dark:text-surface-200">{{ lang.label }}</span>
            <lucide-icon *ngIf="currentLanguage().code === lang.code" [img]="Check" [size]="16" class="ml-auto text-primary-600"></lucide-icon>
          </button>
        </div>

        <!-- Backdrop to close -->
        <div *ngIf="showLanguageMenu()" (click)="showLanguageMenu.set(false)" class="fixed inset-0 z-40 bg-transparent"></div>
      </div>

      <button
        (click)="toggleTheme()"
        class="p-2 rounded-full transition-colors"
        [ngClass]="darkMode() ? 'hover:bg-surface-700 text-surface-300' : 'hover:bg-surface-100 text-surface-600'"
        title="{{ t().header.theme }}"
      >
         <lucide-icon [img]="darkMode() ? Sun : Moon" [size]="20"></lucide-icon>
      </button>

      <!-- Verrouiller le poste — maquettes Menu-Actuel / Menu-SansVente -->
      <button
        (click)="verrouiller()"
        class="p-2 rounded-full transition-colors"
        [ngClass]="darkMode() ? 'hover:bg-surface-700 text-surface-300' : 'hover:bg-surface-100 text-surface-600'"
        [attr.aria-label]="t().verrou.button"
        [title]="t().verrou.button + ' (' + t().verrou.shortcut + ')'"
      >
         <lucide-icon [img]="Lock" [size]="20" aria-hidden="true"></lucide-icon>
      </button>

      <div class="w-px h-6 mx-1" [ngClass]="darkMode() ? 'bg-surface-700' : 'bg-surface-200'"></div>

      <!-- Photo de profil.
           Repli sur les initiales si aucune photo n'est definie OU si son
           chargement echoue : en boutique, le reseau peut lacher et une icone
           d'image cassee est pire que pas de photo. Ouvre un menu contextuel
           (Taches/Configuration/Code NIP/Se deconnecter) au lieu de naviguer
           directement — le lien "tout /settings" reste accessible depuis ce
           menu si besoin. -->
      <div class="relative">
        <button
          (click)="toggleAvatarMenu()"
          class="w-9 h-9 rounded-full overflow-hidden flex items-center justify-center transition-colors shrink-0"
          [ngClass]="darkMode() ? 'bg-surface-700 text-surface-200 hover:ring-2 hover:ring-primary-500' : 'bg-surface-200 text-surface-700 hover:ring-2 hover:ring-primary-400'"
          [title]="userService.profile().name || t().header.title"
        >
          @if (userService.profile().avatar && !photoIndisponible()) {
            <img
              [src]="userService.profile().avatar"
              [alt]="userService.profile().name"
              (error)="photoIndisponible.set(true)"
              class="w-full h-full object-cover"
            />
          } @else {
            <span class="text-xs font-semibold">
              {{ initiales(userService.profile().name) }}
            </span>
          }
        </button>

        <!-- Menu contextuel avatar -->
        <div *ngIf="avatarMenuOpen()" role="menu" [class]="habillageMenu().panneau">
          @for (item of itemsMenu(); track item.id) {
            @if (item.action === 'verrouiller') {
              <button role="menuitem" (click)="verrouiller()" [class]="habillageMenu().ligne + ' ' + habillageMenu().ligneVerrou">
                <lucide-icon [img]="item.icone" [size]="habillageMenu().tailleIcone" [class]="habillageMenu().iconeColoree ? item.couleur : ''" aria-hidden="true"></lucide-icon>
                <span [class]="habillageMenu().libelle">{{ item.libelle }}</span>
                @if (item.pastille) {
                  <span class="ml-auto text-[11px] font-bold">{{ item.pastille }}</span>
                }
              </button>
            } @else if (item.action === 'installer') {
              <button role="menuitem" (click)="installer()" [class]="habillageMenu().ligne">
                <lucide-icon [img]="item.icone" [size]="habillageMenu().tailleIcone" [class]="habillageMenu().iconeColoree ? item.couleur : ''" aria-hidden="true"></lucide-icon>
                <span [class]="habillageMenu().libelle">{{ item.libelle }}</span>
              </button>
            } @else if (item.vue; as vue) {
              <button role="menuitem" (click)="goToSettingsView(vue)" [class]="habillageMenu().ligne">
                <lucide-icon [img]="item.icone" [size]="habillageMenu().tailleIcone" [class]="habillageMenu().iconeColoree ? item.couleur : ''" aria-hidden="true"></lucide-icon>
                <span [class]="habillageMenu().libelle">{{ item.libelle }}</span>
              </button>
            } @else {
              <a role="menuitem" [routerLink]="item.route" (click)="avatarMenuOpen.set(false)" [class]="habillageMenu().ligne">
                <lucide-icon [img]="item.icone" [size]="habillageMenu().tailleIcone" [class]="habillageMenu().iconeColoree ? item.couleur : ''" aria-hidden="true"></lucide-icon>
                <span [class]="habillageMenu().libelle">{{ item.libelle }}</span>
              </a>
            }
          }
          @if (habillageMenu().filet) {
            <div class="border-t my-1" [ngClass]="darkMode() ? 'border-surface-700' : 'border-surface-100'"></div>
          }
          <button role="menuitem" (click)="avatarMenuOpen.set(false); logout()" [class]="habillageMenu().deconnexion">
            <lucide-icon [img]="LogOut" [size]="habillageMenu().tailleIcone" [class]="habillageMenu().iconeDeconnexion" aria-hidden="true"></lucide-icon>
            <span [class]="habillageMenu().libelleDeconnexion">{{ t().header.logout }}</span>
          </button>
        </div>

        <!-- Backdrop to close -->
        <div *ngIf="avatarMenuOpen()" (click)="avatarMenuOpen.set(false)" [class]="habillageMenu().voile"></div>
      </div>

      @if (modePos.estVente()) {
        <button
          (click)="logout()"
          class="p-2 rounded-full transition-colors"
          [ngClass]="darkMode() ? 'hover:bg-danger-900/30 text-surface-300 hover:text-danger-400' : 'hover:bg-danger-50 text-surface-600 hover:text-danger-600'"
          title="{{ t().header.logout }}"
        >
            <lucide-icon [img]="LogOut" [size]="20"></lucide-icon>
        </button>
      }
    </div>
  </header>

  <!-- Cash Session Bar -->
  @if (modePos.estVente()) {
    <app-cash-session-bar [isDark]="darkMode()"></app-cash-session-bar>
  }

  <!-- Appel en cours (entrant/actif/minimisé) — MOB-010, monté une seule fois -->
  <app-call-overlay></app-call-overlay>

  <!-- Installation PWA — MOB-014, visible dès la première connexion -->
  <app-pwa-install-banner></app-pwa-install-banner>
  <app-feuille-installation-ios [(ouverte)]="feuilleInstallation" />

  <!-- Nouvelle version disponible : bandeau sous l'en-tete, feuille du bas si un rechargement s'impose -->
  <app-banniere-mise-a-jour [haut]="enteteHaut()"></app-banniere-mise-a-jour>

  <!-- Main Content Area -->
  <main class="pb-20 h-screen overflow-hidden" [ngClass]="hasActiveSession() ? 'pt-[86px]' : 'pt-14'" [style.padding-top.px]="contenuHaut()">
    <router-outlet></router-outlet>
  </main>

  <!-- Bottom Navigation -->
  <nav class="fixed bottom-0 left-0 right-0 flex items-center justify-around px-1 z-30 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] pb-safe transition-colors border-t"
       [ngClass]="darkMode() ? 'bg-surface-900 border-surface-700' : 'bg-white border-surface-200'">

    @if (modePos.estVente()) {
    <!-- Vente. Le badge signale des ventes encaissees hors ligne, pas encore
         transmises au serveur — sans lui le caissier n'a aucun moyen de le
         savoir. Voir VTE-004. -->
    <app-nav-button
      [label]="t().nav.sales"
      routerLink="/sales"
      routerLinkActive="active"
      [active]="rlaSales.isActive"
      [badge]="cartService.ventesEnAttente()"
      #rlaSales="routerLinkActive"
    >
        <lucide-icon [img]="ShoppingBag"></lucide-icon>
    </app-nav-button>

    <!-- Caisse (transfert + mouvements + cloture + historique, voir
         cash-register-hub.component.ts) — toujours visible, plus
         conditionne a une session active : l'onglet Historique n'en a pas
         besoin (MOB-004/MOB-008). -->
    <app-nav-button
      [label]="t().cash_session.close_cash || 'Caisse'"
      routerLink="/cash-register"
      routerLinkActive="active"
      [active]="rlaCaisse.isActive"
      #rlaCaisse="routerLinkActive"
    >
        <lucide-icon [img]="Wallet"></lucide-icon>
    </app-nav-button>

    <!-- Calendrier -->
    <app-nav-button
      [label]="t().nav.calendar"
      routerLink="/calendar"
      routerLinkActive="active"
      [active]="rlaCalendar.isActive"
      #rlaCalendar="routerLinkActive"
    >
        <lucide-icon [img]="Calendar"></lucide-icon>
    </app-nav-button>

    <!-- RH -->
    <app-nav-button
      [label]="t().nav.hr"
      routerLink="/hr"
      routerLinkActive="active"
      [active]="rlaHr.isActive"
      #rlaHr="routerLinkActive"
    >
        <lucide-icon [img]="Briefcase"></lucide-icon>
    </app-nav-button>

    <!-- Messages -->
    <app-nav-button
      [label]="t().nav.messages"
      routerLink="/messages"
      routerLinkActive="active"
      [active]="rlaMessages.isActive"
      [badge]="chatService.totalUnread()"
      #rlaMessages="routerLinkActive"
    >
        <lucide-icon [img]="MessageCircle"></lucide-icon>
    </app-nav-button>

    } @else {
    <!-- Menu « sans vente » (maquette Menu-SansVente-Accueil) : Accueil, Messages,
         Calendrier, RH, Courriel. Le badge des messages est le nombre REEL de
         non-lus ; il reste a zero (donc absent) tant que la messagerie n'est pas chargee. -->
    <app-nav-button
      [label]="t().nav.home"
      routerLink="/home"
      routerLinkActive="active"
      [active]="rlaAccueil.isActive"
      #rlaAccueil="routerLinkActive"
    >
        <lucide-icon [img]="House"></lucide-icon>
    </app-nav-button>

    <app-nav-button
      [label]="t().nav.messages"
      routerLink="/messages"
      routerLinkActive="active"
      [active]="rlaMessagesRh.isActive"
      [badge]="chatService.totalUnread()"
      #rlaMessagesRh="routerLinkActive"
    >
        <lucide-icon [img]="MessageCircle"></lucide-icon>
    </app-nav-button>

    <app-nav-button
      [label]="t().nav.calendar"
      routerLink="/calendar"
      routerLinkActive="active"
      [active]="rlaCalendarRh.isActive"
      #rlaCalendarRh="routerLinkActive"
    >
        <lucide-icon [img]="Calendar"></lucide-icon>
    </app-nav-button>

    <app-nav-button
      [label]="t().nav.hr"
      routerLink="/hr"
      routerLinkActive="active"
      [active]="rlaHrRh.isActive"
      #rlaHrRh="routerLinkActive"
    >
        <lucide-icon [img]="Briefcase"></lucide-icon>
    </app-nav-button>

    <app-nav-button
      [label]="t().nav.email"
      routerLink="/email"
      routerLinkActive="active"
      [active]="rlaCourrielRh.isActive"
      #rlaCourrielRh="routerLinkActive"
    >
        <lucide-icon [img]="Mail"></lucide-icon>
    </app-nav-button>
    }

  </nav>
</div>

<!-- Verrou en attente / sans NIP : annonce brève, lue par les lecteurs d'écran -->
@if (messageVerrou(); as m) {
  <div role="status" class="fixed z-[90] left-1/2 -translate-x-1/2 bottom-24 max-w-[90vw] rounded-xl px-4 py-2.5 text-sm font-medium text-white shadow-xl"
       style="background:rgba(15,23,42,0.92)">{{ m }}</div>
}

<!-- Écran de verrouillage : hors du conteneur inerte, au-dessus de tout -->
@if (verrou.verrouille()) {
  <app-ecran-verrou />
}
